// Pure sync/drift decision for the Release Info modal, extracted so it is
// unit-testable without a DOM. In a single-commit monorepo the web bundle and
// the API server should report the same git SHA; a mismatch means only one
// side was redeployed. The comparison is meaningless until the API responds
// and while either side is the local-dev fallback ('dev'), where build times
// differ by design.
export type ReleaseSync =
  | { state: 'unknown' }
  | { state: 'in-sync' }
  | { state: 'drift' };

export const resolveReleaseSync = (
  webSha: string,
  apiSha: string | null | undefined,
  apiPending: boolean
): ReleaseSync => {
  if (apiPending || !apiSha || webSha === 'dev' || apiSha === 'dev') {
    return { state: 'unknown' };
  }
  return webSha === apiSha ? { state: 'in-sync' } : { state: 'drift' };
};
